import style from "./mainArticle1.module.scss";
import DCASLogo from "../../../assets/images/logo/D-CAS_logo_primary.svg";
import DCASLogoEn from "../../../assets/images/logo/D-CAS_logo_primary_en.svg";
import BrainIcon from "../../../assets/images/icons/BrainIcon.png";
import DesktopIcon from "../../../assets/images/icons/DesktopIcon.png";
import DigitalIcon from "../../../assets/images/icons/DigitalIcon.png";
import GoodDataIcon from "../../../assets/images/icons/GoodDataIcon.png";
import JobSuggetIcon from "../../../assets/images/icons/JobSuggestIcon.png";
import { useMainScrolling, useLanguage, useUserAgent } from "../../../hooks/hooks";
import { useTranslation } from "react-i18next";

export default function AboutDCAS() {
  const { article2Element } = useMainScrolling();
  const { t } = useTranslation("aboutDcas");
  const { isKorean } = useLanguage();
  const { isTablet } = useUserAgent();

  return (
    <section className={style.section5} ref={article2Element}>
      <div className={style.middleBox}>
        {isKorean ? (
          <img className={style.imageArea} src={DCASLogo} alt={"D-CAS Secondary Logo"} />
        ) : (
          <img className={style.imageArea} src={DCASLogoEn} alt={"D-CAS Secondary Logo English"} />
        )}
      </div>
      <div />
      <p className={style.titleArea}>
        <span className={style.line1}>{t("whats.line1")}</span>
        <span className={style.line2}>{t("whats.line2")}</span>
      </p>
      <p className={style.subtitleArea}>{t("whats.line3")}</p>
      <div className={style.boxContainer}>
        <div className={style.roundedBoxArea}>
          <img className={style.logoIcon} src={DigitalIcon} alt={"Brain Icon"} />
          <div>
            <p className={style.titleArea}>{t("firstAns.title")}</p>
            <p className={style.subtitleArea}>
              <span>{t("firstAns.desc.line1")}</span>
              {isTablet ? <br /> : null}
              <span>{t("firstAns.desc.line2")}</span>
            </p>
          </div>
        </div>
        <div className={style.roundedBoxArea}>
          <img className={style.logoIcon} src={DesktopIcon} alt={"Brain Icon"} />
          <div>
            <p className={style.titleArea}>{t("secondAns.title")}</p>
            <p className={style.subtitleArea}>
              <span>{t("secondAns.desc.line1")}</span>
              {isTablet ? <br /> : null}
              <span>{t("secondAns.desc.line2")}</span>
            </p>
          </div>
        </div>
        <div className={style.roundedBoxArea}>
          <img className={style.logoIcon} src={JobSuggetIcon} alt={"Brain Icon"} />
          <div>
            <p className={style.titleArea}>{t("thirdAns.title")}</p>
            <p className={style.subtitleArea}>
              <span>{t("thirdAns.desc.line1")}</span>
              {isTablet ? <br /> : null}
              <span>{t("thirdAns.desc.line2")}</span>
            </p>
          </div>
        </div>
        <div className={style.roundedBoxArea}>
          <img className={style.logoIcon} src={BrainIcon} alt={"Brain Icon"} />
          <div>
            <p className={style.titleArea}>{t("fourthAns.title")}</p>
            <p className={style.subtitleArea}>
              <span>{t("fourthAns.desc.line1")}</span>
              {isTablet ? <br /> : null}
              <span>{t("fourthAns.desc.line2")}</span>
            </p>
          </div>
        </div>
        <div className={style.roundedBoxArea}>
          <img className={style.logoIcon} src={GoodDataIcon} alt={"Brain Icon"} />
          <div>
            <p className={style.titleArea}>{t("fifthAns.title")}</p>
            <p className={style.subtitleArea}>{t("fifthAns.desc.line1")}</p>
          </div>
        </div>
        <div style={{ marginBottom: "100px" }}></div>
      </div>
    </section>
  );
}
